const parentTestActions = {
    types: {
        CHILD_TESTS_LOAD_SUCCESS: 'CHILD_TESTS_LOAD_SUCCESS',
        CHILD_TESTS_LOAD_FAILED: 'CHILD_TESTS_LOAD_FAILED',
        DESCRIPTION_DOC_CONFIRMED: 'DESCRIPTION_DOC_CONFIRMED',
        DELIVER_TEST_OFFLINE: 'DELIVER_TEST_OFFLINE',
        SET_CHILD_TEST_HAS_COMPLETELY_PLAYED_DESCRIPTION_MEDIA: 'SET_CHILD_TEST_HAS_COMPLETELY_PLAYED_DESCRIPTION_MEDIA',
        SET_PARENT_TEST_QUESTION_SET: 'SET_PARENT_TEST_QUESTION_SET',
        SET_TEST_STARTED_OFFLINE: 'SET_TEST_STARTED_OFFLINE',
        UPDATE_MINUTES_UNTIL_START_TIME: 'UPDATE_MINUTES_UNTIL_START_TIME',
    },

    confirmDescriptionDocument(body) {
        return { type: this.types.DESCRIPTION_DOC_CONFIRMED, body };
    },

    deliverChildTestOffline(body) {
        return { type: this.types.DELIVER_TEST_OFFLINE, body };
    },

    setChildTestStartedOffline(assessmentRunId) {
        return { type: this.types.SET_TEST_STARTED_OFFLINE, assessmentRunId };
    },

    setChildTestHasCompletelyPlayedDescriptionMedia(assessmentRunId, hasCompletelyPlayedMedia) {
        return { type: this.types.SET_CHILD_TEST_HAS_COMPLETELY_PLAYED_DESCRIPTION_MEDIA, assessmentRunId, hasCompletelyPlayedMedia };
    },

    childTestsLoadSuccess(body) {
        return { type: this.types.CHILD_TESTS_LOAD_SUCCESS, body };
    },

    childTestsLoadFailed(body) {
        return { type: this.types.CHILD_TESTS_LOAD_FAILED, body };
    },

    setParentTestQuestionSet(body) {
        return { type: this.types.SET_PARENT_TEST_QUESTION_SET, body };
    },

    updateMinutesUntilChildStartTime(body) {
        return { type: this.types.UPDATE_MINUTES_UNTIL_START_TIME, body };
    },
};

export default parentTestActions;
